<script>
import NavigationMenu from '@/components/NavigationMenu'

export default
{
    name: 'app',

    render () 
    {
        return (
            <div id='app' ref='app'>

                {/* This makes the app area start right from the top */}
                <div style={{ height: 0 }}>&nbsp;</div>

                <NavigationMenu />

                <keep-alive>
                    <router-view ref='router' />
                </keep-alive>
            </div>
        );
    },

    created ()
    {
    },

    mounted ()
    {
        this.$router.afterEach((to, from, next) =>
        {
            setTimeout(() => window.scrollTo(0, 1), 50)
            setTimeout(() => window.scrollTo(0, 0), 100)
        });

        setTimeout(() =>
        {
            console.log('Loading Drift')
            this.loadDrift()
            
            window.drift.on('ready', (api, widget) =>
            {
                const showChatIn = 1000 * 60 * 1.3
                console.log('Auto showing Drift message in', showChatIn)

                setTimeout(() =>
                {
                    if (this.$route.path != '/')
                    {
                        return console.log('Should show Drift message but user is no longer on landing page')
                    }

                    window.drift.api.showWelcomeOrAwayMessage()
                }, showChatIn)
            })
        }, 10000)
    },

    data ()
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        loadDrift ()
        {
            /* eslint-disable */ 
            // generated script

            !function() {
            var t = window.driftt = window.drift = window.driftt || [];
            if (!t.init) {
                if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
                t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
                t.factory = function(e) {
                return function() {
                    var n = Array.prototype.slice.call(arguments);
                    return n.unshift(e), t.push(n), t;
                };
                }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
                }), t.load = async function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
                };
            }
            }();
            drift.SNIPPET_VERSION = '0.3.1';
            drift.load('3t9yyxw3axb5');

            /* eslint-enable */
        }
    },
    
    components:
    {
        NavigationMenu
    }
}
</script>

<style lang='less'>
@import '~@/styles/app.less';

#app
{
}
</style>



// WEBPACK FOOTER //
// src/App.vue